/*
 * @Author: your name
 * @Date: 2021-07-08 08:46:32
 * @LastEditTime: 2022-11-03 15:18:29
 * @LastEditors: 谢树和 shuhe.xie@southgis.com
 * @Description: In User Settings Edit
 * @FilePath: \maine:\git\xadc\src\main.js
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './router/interceptor'
import store from './store'

import vant from 'vant'
Vue.use(vant)
import 'vant/lib/index.css'

import axios from 'axios'
Vue.prototype.$axios = axios
Vue.$bus = Vue.prototype.$bus = new Vue()

import VConsole from 'vconsole'
// var vConsole = new VConsole()
// Vue.use(vConsole)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
